
<template>
  <div>
    <div class="title-text">{{title}}</div>
    <div>{{text}}</div>
  </div>
</template>

<script>
export default {
  name: 'input-box',
  props: {
    text: { type: String },
    title: { type: String }
  }
}
</script>

<style lang="scss" scoped>
@import './../../unified.scss';
.title-text {
  margin-top: 20px;
  font-size: 18px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Atoms/TitleAndText.vue